var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Model, { attr, belongsTo } from '@ember-data/model';
import { computed } from '@ember/object';
export const VALIDATION_FIELD = {
  CURRENCY: {
    field: 'currency',
    translationKey: 'channelListings.listingNotification.listingError.errorType.field.currency'
  },
  DESCRIPTION: {
    field: 'description',
    translationKey: 'channelListings.listingNotification.listingError.errorType.field.description'
  },
  DISPLAY_NAME: {
    field: 'display_name',
    translationKey: 'channelListings.listingNotification.listingError.errorType.field.displayName'
  },
  URI: {
    field: 'uri',
    translationKey: 'channelListings.listingNotification.listingError.errorType.field.uri'
  },
  IMAGE_URIS: {
    field: 'image_uris',
    translationKey: 'channelListings.listingNotification.listingError.errorType.field.imageUris'
  },
  PRICE: {
    field: 'price',
    translationKey: 'channelListings.listingNotification.listingError.errorType.field.price'
  }
};
export const WARNING_FIELD = {
  UPC: {
    field: 'upc',
    translationKey: 'channelListings.listingNotification.listingError.warningType.field.gtin'
  },
  MPN: {
    field: 'mpn',
    translationKey: 'channelListings.listingNotification.listingError.warningType.field.mpn'
  },
  BRAND: {
    field: 'brand',
    translationKey: 'channelListings.listingNotification.listingError.warningType.field.brand'
  },
  DESCRIPTION: {
    field: 'description',
    translationKey: 'channelListings.listingNotification.listingError.warningType.field.description'
  },
  AGE_GROUP: {
    field: 'age_group',
    translationKey: 'channelListings.listingNotification.listingError.warningType.field.ageGroup'
  },
  COLOR: {
    field: 'color',
    translationKey: 'channelListings.listingNotification.listingError.warningType.field.color'
  },
  GENDER: {
    field: 'gender',
    translationKey: 'channelListings.listingNotification.listingError.warningType.field.gender'
  },
  SIZE: {
    field: 'size',
    translationKey: 'channelListings.listingNotification.listingError.warningType.field.size'
  },
  ISBN: {
    field: 'isbn',
    translationKey: 'channelListings.listingNotification.listingError.warningType.field.isbn'
  },
  CONDITION: {
    field: 'condition',
    translationKey: ''
  },
  BUNDLE: {
    field: 'bundle',
    translationKey: ''
  },
  MULTIPACK: {
    field: 'multipack',
    translationKey: ''
  }
};
const RESOLVABLE_CHANNEL_ERRORS = new Set(['Image too small. Upload an image (JPG, PNG, GIF) that is at least 250x250 pixels.', 'Invalid item image. Upload a valid image (JPG, PNG, GIF) for this item.', 'Invalid value [gtin]. Use a globally valid UPC', 'Image size must be at least 500 x 500 pixels', "Incorrect product identifier [mpn]. Use the manufacturer's product identifiers (GTIN, brand, MPN)", 'Content is in uppercase: Make sure your title and description are not entirely in uppercase. In your description, capitalize only the first word of a sentence and any proper nouns like brand names. Use lowercase for everything else.', 'Incorrect value [identifier exists]. This item has an internationally recognized, unique identifier. Submit a valid GTIN, and either set this value to true or remove this value.', 'Duplicate value [gtin]. Submit a unique value for each product', "Unsupported value due to restrictions: GTIN [gtin]. Use a GTIN that's not restricted; GS1 hasn't released the current value yet", "Invalid value [gtin]. Submit a valid value based on Google's product data specification", 'GTIN not related to brand. Use a globally valid GTIN that is related to the brand you submitted', 'Unsupported value (reserved) [gtin]. Use a GTIN that doesn\'t start with "2", "02", or "04"', 'Image uses a single color [image link]. A single-color image can only be used for specific types of products. Update the image to better reflect the product, then resubmit your feed.', 'Image too big. Use an image that has a resolution less than 64 megapixels and file size smaller than 16MB', 'Generic image. Use an image that shows the product']);
var ObjectMapType = /*#__PURE__*/function (ObjectMapType) {
  ObjectMapType["ITEM_VARIATION"] = "ITEM_VARIATION";
  ObjectMapType["INVENTORY_LEVEL"] = "INVENTORY_LEVEL";
  return ObjectMapType;
}(ObjectMapType || {});
export let ERROR_TYPE = /*#__PURE__*/function (ERROR_TYPE) {
  ERROR_TYPE["ERROR"] = "ERROR";
  ERROR_TYPE["WARNING"] = "WARNING";
  return ERROR_TYPE;
}({});
export let OccurredBy = /*#__PURE__*/function (OccurredBy) {
  OccurredBy["CHANNEL_NON_USER_RESOLVABLE"] = "CHANNEL_NON_USER_RESOLVABLE";
  OccurredBy["CHANNEL_USER_RESOLVABLE"] = "CHANNEL_USER_RESOLVABLE";
  OccurredBy["SYSTEM_USER_RESOLVABLE"] = "SYSTEM_USER_RESOLVABLE";
  OccurredBy["SYSTEM_NON_USER_RESOLVABLE"] = "SYSTEM_NON_USER_RESOLVABLE";
  return OccurredBy;
}({});
let ObjectMapAcknowledgmentError = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = attr('number'), _dec4 = attr('number'), _dec5 = attr('number'), _dec6 = attr('string'), _dec7 = attr('boolean'), _dec8 = attr('string'), _dec9 = attr('number'), _dec10 = attr('string'), _dec11 = attr('json-or-value'), _dec12 = attr('string'), _dec13 = attr('string'), _dec14 = attr('date'), _dec15 = attr('string'), _dec16 = attr('date'), _dec17 = attr('date'), _dec18 = attr('date'), _dec19 = attr('date'), _dec20 = attr('date'), _dec21 = attr(), _dec22 = attr('string'), _dec23 = belongsTo('channels/object-map', {
  async: false
}), _dec24 = computed('errorType'), _dec25 = computed('errorType'), _dec26 = computed('translationKey.length'), _dec27 = computed('errorProblem', 'occurredBy'), _dec28 = computed('occurredBy'), _dec29 = computed('occurredBy'), _dec30 = computed('errorProblem'), _dec31 = computed('errorRaw.{documentation,suggestion}'), (_class = class ObjectMapAcknowledgmentError extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantId", _descriptor, this);
    _initializerDefineProperty(this, "channelId", _descriptor2, this);
    _initializerDefineProperty(this, "objectMapId", _descriptor3, this);
    _initializerDefineProperty(this, "objectMapVersion", _descriptor4, this);
    _initializerDefineProperty(this, "objectMapRevision", _descriptor5, this);
    _initializerDefineProperty(this, "objectMapType", _descriptor6, this);
    _initializerDefineProperty(this, "userResolvable", _descriptor7, this);
    _initializerDefineProperty(this, "errorType", _descriptor8, this);
    _initializerDefineProperty(this, "errorCount", _descriptor9, this);
    _initializerDefineProperty(this, "errorProblem", _descriptor10, this);
    _initializerDefineProperty(this, "errorRaw", _descriptor11, this);
    _initializerDefineProperty(this, "errorResolution", _descriptor12, this);
    _initializerDefineProperty(this, "occurredBy", _descriptor13, this);
    _initializerDefineProperty(this, "occurredAt", _descriptor14, this);
    _initializerDefineProperty(this, "resolvedBy", _descriptor15, this);
    _initializerDefineProperty(this, "resolvedAt", _descriptor16, this);
    _initializerDefineProperty(this, "createdAt", _descriptor17, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor18, this);
    _initializerDefineProperty(this, "deletedAt", _descriptor19, this);
    _initializerDefineProperty(this, "lastErroredAt", _descriptor20, this);
    // Added fields by normalizer
    _initializerDefineProperty(this, "fields", _descriptor21, this);
    _initializerDefineProperty(this, "translationKey", _descriptor22, this);
    // Relationships
    _initializerDefineProperty(this, "objectMap", _descriptor23, this);
  }
  get isErrorTypeError() {
    return this.errorType === ERROR_TYPE.ERROR;
  }
  get isErrorTypeWarning() {
    return this.errorType === ERROR_TYPE.WARNING;
  }
  get hasTranslationKey() {
    return Boolean(this.translationKey && this.translationKey.length > 0);
  }
  get isResolvableInSquareError() {
    if (this.occurredBy === OccurredBy.SYSTEM_USER_RESOLVABLE) {
      return true;
    }
    return RESOLVABLE_CHANNEL_ERRORS.has(this.errorProblem);
  }
  get isOccurredBySystem() {
    return this.occurredBy === OccurredBy.SYSTEM_USER_RESOLVABLE || this.occurredBy === OccurredBy.SYSTEM_NON_USER_RESOLVABLE;
  }
  get isOccurredByChannel() {
    return this.occurredBy === OccurredBy.CHANNEL_NON_USER_RESOLVABLE || this.occurredBy === OccurredBy.CHANNEL_USER_RESOLVABLE;
  }
  get errorIsGoogleShippingAndTaxError() {
    return this.errorProblem.includes('[shipping]') || this.errorProblem.includes('[tax]');
  }
  isGoogleErrorRaw(errorRaw) {
    if (!errorRaw) {
      return false;
    }
    if (typeof errorRaw !== 'object') {
      return false;
    }
    return 'documentation' in errorRaw;
  }
  get helpArticle() {
    if (this.isGoogleErrorRaw(this.errorRaw)) {
      return this.errorRaw.documentation;
    }
    return null;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "channelId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "objectMapId", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "objectMapVersion", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "objectMapRevision", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "objectMapType", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "userResolvable", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "errorType", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "errorCount", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "errorProblem", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "errorRaw", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "errorResolution", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "occurredBy", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "occurredAt", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "resolvedBy", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "resolvedAt", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "deletedAt", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "lastErroredAt", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "fields", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "translationKey", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "objectMap", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isErrorTypeError", [_dec24], Object.getOwnPropertyDescriptor(_class.prototype, "isErrorTypeError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isErrorTypeWarning", [_dec25], Object.getOwnPropertyDescriptor(_class.prototype, "isErrorTypeWarning"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasTranslationKey", [_dec26], Object.getOwnPropertyDescriptor(_class.prototype, "hasTranslationKey"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isResolvableInSquareError", [_dec27], Object.getOwnPropertyDescriptor(_class.prototype, "isResolvableInSquareError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOccurredBySystem", [_dec28], Object.getOwnPropertyDescriptor(_class.prototype, "isOccurredBySystem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOccurredByChannel", [_dec29], Object.getOwnPropertyDescriptor(_class.prototype, "isOccurredByChannel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorIsGoogleShippingAndTaxError", [_dec30], Object.getOwnPropertyDescriptor(_class.prototype, "errorIsGoogleShippingAndTaxError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "helpArticle", [_dec31], Object.getOwnPropertyDescriptor(_class.prototype, "helpArticle"), _class.prototype)), _class));
export { ObjectMapAcknowledgmentError as default };